import { Expose, Type } from 'class-transformer';

export class ProjectBudgetEntryModel {
  public id? = null;
  @Expose({ name: 'member_id' })
  public memberId?: number | null = null;
  @Expose({ name: 'project_id' })
  public projectId?: number | null = null;
  // Time is the time budget for a task or assignee.
  @Type(() => Number)
  public seconds: number | null = null;
  // Monetary is either the all-in budget or the expenditure rate of the task or assignee.
  @Type(() => Number)
  public monetary: number | null = null;
  // For new tasks, the negative task id is sent to the server.
  @Expose({ name: 'task_id' })
  public taskId?: number | null = null;
}
